import { Link } from "react-router-dom";

export default function AboutIntro() {
  return (
    <section className="rounded-lg bg-primary-500 text-background-50 p-6 md:p-10">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-center">
        <div className="lg:col-span-2">
          <h2 className="font-heading font-extrabold text-xl md:text-2xl">关于 h动漫</h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-background-100/95 max-w-2xl">
            h动漫是面向二次元爱好者的动漫资讯与作品推荐平台。我们聚合最新的动漫新闻与预告，
            建立丰富多元的作品资料库，并以专业的视角提供评论与解析，
            让每一位爱好者都能快速找到感兴趣的内容，深入了解每一部作品背后的故事。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-1.5 h-10 px-5 rounded-md bg-background-50 text-primary-600 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解我们 <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-1.5 h-10 px-5 rounded-md border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              联系我们
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-3 lg:grid-cols-1 gap-4">
          {[
            { num: "2000+", label: "收录作品" },
            { num: "500+", label: "深度评论" },
            { num: "每日", label: "资讯更新" },
          ].map((s) => (
            <div key={s.label} className="rounded-lg bg-background-50/10 px-4 py-3 text-center lg:text-left">
              <p className="font-heading font-extrabold text-xl md:text-2xl">{s.num}</p>
              <p className="mt-0.5 text-xs text-background-100/90">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}